export default {
  clientReason: [
    { title: 'فراموش کردم', value: 'FORGET' },
    { title: 'کار پیش بینی نشده روی داد', value: 'BUSY' },
    { title: 'موارد دیگر', value: 'OTHER' }
  ]
};
